<div class="device-list-container">
  <div class="content">
    <div class="devices">
      <kion-truck-list></kion-truck-list>
    </div>
  </div>
</div>
